import store from "../index.js";
import api from "../../utils/api";

export const modules = {
  store,
};

export const state = {
  _item: {},
  _items: [],
  _alarmtalkTemplates: [],
};

export const mutations = {
  setGomService(state, item) {
    state._item = item;
  },
  setAlarmtalkTemplates(state, item) {
    state._alarmtalkTemplates = item.items;
  },
};

export const actions = {
  async acGomService({ commit }, query) {
    try {
      const result = await api.get(
        `/api/v1/gom/service?role=${query.role}&domain=${query.domain}&action=${query.action}`
      );
      if (result?.data?.code === 0) {
        commit("setGomService", result.data.data);
        return true;
      }
      commit("setGomService", {});
      return false;
    } catch (err) {
      console.log("err", err.message);
      commit("setGomService", {});
      return false;
    }
  },
  async acAlarmtalkList({ commit }, querys) {
    try {
      const result = await api.get(
        `/api/v1/gom/alarmtalk?page=${querys.page}&pageSize=${querys.pageSize}`
      );
      if (result?.data?.code === 0) {
        commit("setAlarmtalkTemplates", result.data.data);
        return true;
      }
      return false;
    } catch (err) {
      console.log("err", err.message);
      return false;
    }
  },
};

export const getters = {};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
